@use 'styles/functions/rem' as *;

.tabs {
    display: flex;
    flex-direction: row;
    justify-content: center;
    width: 100%;
}
